import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
  loadingCompare: false,
  dataCompare: null,
  errorsCompare: null,
}

export const getters = {
  getOverview(state) {
    return state.data
  },
  getCompare(state) {
    return state.dataCompare
  },
}

export const mutations = {
  SET_OVERVIEW_REQUESTED(state) {
    state.loading = true
  },
  SET_OVERVIEW_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_OVERVIEW_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  SET_COMPARE_REQUESTED(state) {
    state.loadingCompare = true
  },
  SET_COMPARE_RECEIVED(state, newData) {
    state.loadingCompare = false
    state.dataCompare = newData
    state.errorsCompare = null
  },
  SET_COMPARE_RECEIVED_FAILED(state, error) {
    state.loadingCompare = false
    state.errorsCompare = error
  },
}

export const actions = {
  async fetchingOverview({ commit }, params) {
    commit('SET_OVERVIEW_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/measure/overview/',
        payload: { ...params },
      })
      commit('SET_OVERVIEW_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_OVERVIEW_RECEIVED_FAILED', error)
    }
  },
  async fetchingCompare({ commit }, params) {
    commit('SET_COMPARE_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/measure/overview/',
        payload: { ...params },
      })
      commit('SET_COMPARE_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_COMPARE_RECEIVED_FAILED', error)
    }
  },
}
